var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { BaseSingletonService, Singleton } from '~/services/service.base';
import { ServiceConfig } from '~/services/service.config';
import { EFileSize } from '~/shared/types/file';
export const THUMB_EXTENSION = 'jpg';
export let ServiceFile = class ServiceFile extends BaseSingletonService {
    serviceConfig;
    constructor(serviceConfig) {
        super();
        this.serviceConfig = serviceConfig;
    }
    getThumbnailLink(size, withWatermark, item) {
        if (item.obj_type === 'video' && item.sub_type === 'youtube') {
            return `//img.youtube.com/vi/${item.path}/0.${THUMB_EXTENSION}`;
        }
        const baseLink = `${this.serviceConfig.awsUrl}${item.path}_`;
        const linkSuffix = withWatermark ? `_wtrm.${THUMB_EXTENSION}` : `.${THUMB_EXTENSION}`;
        if (Object.values(EFileSize).includes(size)) {
            return `${baseLink}${size}${linkSuffix}`;
        }
        return `${baseLink}${EFileSize.large}${linkSuffix}`;
    }
};
ServiceFile = __decorate([
    Singleton(),
    __metadata("design:paramtypes", [typeof (_a = typeof ServiceConfig !== "undefined" && ServiceConfig) === "function" ? _a : Object])
], ServiceFile);
